import React, { useState, useEffect } from "react";
import config from "../../config";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

//components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress } from "@material-ui/core";
import Modal from "../modals/Modal";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  IconButton,
  Select,
  FormControl,
  MenuItem,
} from "@material-ui/core";
import SnackbarMessage from "../modals/SnackbarMessage";
import {
  CloudDownload as Download,
} from "@material-ui/icons";

// styles
import useStyles from "./styles";
import useStylesTable from "../products/styles";

const PartnerReport = () => {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [partners, setPartners] = useState([]);
  const [membershipType, setMembershipType] = useState({ id: 'TODAS', name: 'TODAS' });
  const [isTraveler, setIsTraveler] = useState('Viajero y no viajero');
  const [partnerStatus, setPartnerStatus] = useState('TODOS');
  const [allMemberships, setAllMemberships] = useState([]);
  const [allTravelersType, setAllTravelersType] = useState(['Viajero', 'No viajero', 'Viajero y no viajero']);
  const [totalPartners, setTotalPartners] = useState(0);
  const [allStatus, setAllStatus] = useState([]);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fetchMemberships = async () => {
    fetch(baseUrl + "membershipTypeReport",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error == null) {
          setAllMemberships(data.content);
          fetchStatus();
        } else {
          setShowModal(true);
          setIsLoading(false);
        }
      }).catch(error => setIsLoading(false));
  }

  const fetchStatus = async () => {
    fetch(baseUrl + "statusToReport",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error == null) {
          setAllStatus(data.content);
        } else {
          setShowModal(true);
        }
        setIsLoading(false);
      }).catch(error => setIsLoading(false));
  }

  useEffect(() => {
    fetchMemberships();
  }, []);

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const fetchPartners = async (body) => {
    fetch(baseUrl + "partnerReport",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.status == "Ok") {
          setPartners(data.content);
          setTotalPartners(data.total);
        } else {
          setShowModal(true);
        }
      }).catch(error => null);
  }

  const onClickSearch = (e) => {
    const body = {
      membershipType: membershipType.name, traveler: isTraveler, status: partnerStatus
    };

    fetchPartners(body);
  }

  const onClickSave = () => {
    var doc = new jsPDF()
    var totalPagesExp = '{total_pages_count_string}';

    doc.text('Socios - KochulGym', 14, 20);

    doc.autoTable({
      head: [['Nombre', 'Membrecía', 'Viajero', 'Estatus', 'Teléfono', 'Correo', 'Fecha de inicio de membrecía', 'Fecha de vencimiento de membrecía']],
      columns: [
        { dataKey: 'name', header: 'Nombre' },
        { dataKey: 'membershipType', header: 'Membrecía' },
        { dataKey: 'isTraveler', header: 'Viajero' },
        { dataKey: 'partnerStatus', header: 'Estatus' },
        { dataKey: 'phone', header: 'Teléfono' },
        { dataKey: 'email', header: 'Correo' },
        { dataKey: 'membershipStartDate', header: 'Fecha de inicio de membrecía' },
        { dataKey: 'dueDate', header: 'Fecha de vencimiento de membrecía' },
      ],
      body: bodyRows(),
      startY: 30,
      didDrawPage: function (data) {
        // Footer
        var str = 'Página ' + doc.internal.getNumberOfPages()
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' de ' + totalPagesExp
        }
        doc.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        doc.text(str, data.settings.margin.left, pageHeight - 10)
      },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    doc.save("Socios.pdf");
  }

  function bodyRows() {
    var body = [];
    partners.map(({ name, membershipType, isTraveler, partnerStatus, phone, email, membershipStartDate, dueDate }) => (
      body.push({
        name: name,
        membershipType: membershipType,
        isTraveler: isTraveler,
        partnerStatus: partnerStatus,
        phone: phone,
        email: email,
        membershipStartDate: membershipStartDate,
        dueDate: dueDate
      })
    ));

    return body;
  }

  const handleChange = (e) => {
    const value = e.target.value;
    if (value != '') {
      var name = '';

      allMemberships.map((option) => {
        if (option.id == value) {
          name = option.membershipName;
        }
      });

      setMembershipType({ ...membershipType, id: value, name: name });
    } else {
      setMembershipType({ ...membershipType, id: 'TODAS', name: 'TODAS' });
    }
  }

  const handleChangeTraveler = event => {
    var value = event.target.value;
    setIsTraveler(value);
  };

  const handleChangeStatus = (e) => {
    const value = e.target.value;
    setPartnerStatus(value);
  }

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        {isLoading ? (
          <CircularProgress size={26} className={classes.loginLoader} />
        ) : (
          <div style={{ height: "100%" }}>
            <PageTitle title="Socios" />

            <div className={classesTable.divCardSaleDos}>

              <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "25px", textAlign: "justify", backgroundColor: "#fff", borderRadius: "4px", paddingTop: "8px", paddingBottom: "8px" }}>
                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "30%" }}>
                    <div style={{ width: "90%" }}>
                      <text style={{ color: "#000", marginLeft: "24px" }}>Membrecía</text>
                      <FormControl className={classes.formControl}>
                        <Select
                          onChange={handleChange}
                          displayEmpty
                          value={membershipType.id}
                          style={{ color: "#000", marginLeft: "24px" }}
                        >
                          <MenuItem value="TODAS"> TODAS </MenuItem>
                          {allMemberships.map((option) => (
                            <MenuItem value={option.id}>{option.membershipName}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div style={{ alignItems: "center", textAlign: "justify", width: "30%" }}>
                    <div style={{ width: "90%" }}>
                      <text style={{ color: "#000", marginLeft: "24px" }}>Socio</text>
                      <FormControl className={classes.formControl}>
                        <Select
                          onChange={handleChangeTraveler}
                          displayEmpty
                          value={isTraveler}
                          style={{ color: "#000", marginLeft: "24px" }}
                        >
                          {allTravelersType.map((option) => (
                            <MenuItem value={option}>{option}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "40%" }}>
                    <div style={{ width: "90%" }}>
                      <text style={{ color: "#000", marginLeft: "24px" }}>Estatus</text>
                      <FormControl className={classes.formControl}>
                        <Select
                          onChange={handleChangeStatus}
                          displayEmpty
                          value={partnerStatus}
                          style={{ color: "#000", marginLeft: "24px" }}
                        >
                          <MenuItem value="TODOS"> TODOS </MenuItem>
                          {allStatus.map((option) => (
                            <MenuItem value={option.name}>{option.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <button
                      className={classes.enableButtonDate}
                      onClick={onClickSearch}
                    >Buscar</button>

                    <div style={{ height: "50px", width: "2px", backgroundColor: "#E0E0E0", margin: "auto", marginLeft: "30px", marginRight: "30px" }} />
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "20%" }}>
                    <IconButton
                      onClick={onClickSave}
                      className={classes.enableButtonDate}
                    >
                      <Download style={{ marginRight: "8px" }} />
                      Descargar
                    </IconButton>
                  </div>
                </div>
              </div>

              <div style={{ textAlign: "right", backgroundColor: "#fff", paddingTop: "8px", paddingBottom: "8px", paddingRight: "24px", marginBottom: "25px", borderRadius: "4px" }}>
                <text style={{ color: "#000" }}>{"Total: " + totalPartners}</text>
              </div>

              <div style={{ alignItems: "center", justify: 'center', textAlign: "right", backgroundColor: "#fff", borderRadius: "4px", padding: '16px', width: "100%", height: "100%" }}>
                <Table style={{ marginBottom: "20px", borderCollapse: "collapse" }}>
                  <TableHead>
                    <TableRow className={classesTable.rootInvert} >
                      <TableCell size='small' style={{ fontSize: "14px" }} >Nombre</TableCell>
                      <TableCell size='small' style={{ fontSize: "14px" }} >Membrecía</TableCell>
                      <TableCell size='small' style={{ fontSize: "14px" }} >Viajero</TableCell>
                      <TableCell size='small' style={{ fontSize: "14px", textAlign: "center" }} >Estatus</TableCell>
                      <TableCell size='small' style={{ fontSize: "14px", textAlign: "center" }} >Teléfono</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >Correo</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >Fecha de inicio de membrecía</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >Fecha de vencimiento de membrecía</TableCell>
                      {/*{keys.map(key => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {partners.map(({ name, membershipType, isTraveler, partnerStatus, phone, email, membershipStartDate, dueDate }) => (
                      <TableRow className={classesTable.rowWithHover} style={{ height: "20px", borderBottom: "1pt solid #D9D0D0" }}>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{name}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{membershipType}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >{isTraveler}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >{partnerStatus}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >{phone}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >{email}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >{membershipStartDate}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px", textAlign: "center" }} >{dueDate}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default PartnerReport;
